export type Nullable<T> = T | null;
export type Nullish<T> = Nullable<T> | undefined;

export type WithRequired<TType, Key extends keyof TType> = TType & { [P in Key]-?: TType[P] };
export type WithOptional<TType, Key extends keyof TType> = Omit<TType, Key> & Partial<Record<Key, TType[Key]>>;
export type PickRequired<TType, Key extends keyof TType> = Pick<TType, Key> & Partial<Omit<TType, Key>>;
export type PickOptional<TType, Key extends keyof TType> = Omit<TType, Key> & Partial<Pick<TType, Key>>;

export type Enum<TObject extends Record<string, string | number>> = TObject[keyof TObject];
export type ArrayValues<T extends readonly unknown[]> = T[number];

export type LooseAutocomplete<T extends string> = T | (string & {});

export type AsChild = { asChild?: boolean };

export const WebComponentMode = {
    Website: "website",
    ShoppingCart: "shopping-cart",
    ProjectRequest: "project-request",
} as const;
export type WebComponentModeEnum = Enum<typeof WebComponentMode>;

export const Site = {
    Default: "default",
    NorthAmerica: "north_america",
} as const;
export type SiteEnum = Enum<typeof Site>;

export type Locale = `${string}_${string}`;

export type ResponseSuccess<T extends Record<string, unknown>> = { success: true } & T;
export type ResponseError<T extends Record<string, unknown>> = { success: false } & T;
export type ApiResponse<
    S extends Record<string, unknown> = Record<string, unknown>,
    E extends Record<string, unknown> = Record<string, unknown>,
> = ResponseSuccess<S> | ResponseError<E>;

declare const __brand: unique symbol;
export type Brand<T, B extends string> = T & { [__brand]: B };

export * from "./downloads.ts";
export * from "./images.ts";
export * from "./navigation.ts";
export * from "./product.ts";
export * from "./smart-number.ts";
